import Blue from '~/core';

new Blue({
  name: 'DataTable',
  selector: '.data-table ',
  setup(table) {
    const rows = table.querySelectorAll('.data-table__row');
    const more = table.querySelector('.data-table__more .btn');

    if (rows.length > 4) table.classList.add('truncate');

    const toggler = new this.$toggle({
      trigger: more,
      content: table,
      props: ['height'],
      externalEvents: true,
    });

    const toggle = () => {
      table.classList.add('expanded');
      toggler.toggle();
      more.removeEventListener('click', toggle);
    };
    
    if(more){
      more.addEventListener('click', toggle);
    }      
  },
});

new Blue({
  name: 'DataTableAnimation',
  selector: '.doggett-toyota .data-table-animation-container',
  setup(container) {
    const allContainers = document.querySelectorAll('.data-table-animation-container');
    const trigger = container.previousElementSibling;
    let isInitialized = false;

    const handleTrigger = () => {
      const isExpanded = container.hasAttribute('data-expanded');

      allContainers.forEach(container => {
        container.removeAttribute('data-expanded');
      });

      if (!isExpanded) container.setAttribute('data-expanded', '');
    };

    const handleKeydown = (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleTrigger();
      }
    };

    const initializeTrigger = () => {
      if (!isInitialized) {
        trigger.setAttribute('role', 'button');
        trigger.setAttribute('tabindex', '0');
        trigger.addEventListener('click', handleTrigger);
        trigger.addEventListener('keydown', handleKeydown);
        isInitialized = true;
      }
    };

    const cleanupTrigger = () => {
      if (isInitialized) {
        allContainers.forEach(container => {
          container.removeAttribute('data-expanded');
        });
        trigger.removeAttribute('role');
        trigger.removeAttribute('tabindex');
        trigger.removeEventListener('click', handleTrigger);
        trigger.removeEventListener('keydown', handleKeydown);
        isInitialized = false;
      }
    };

    const adjustTrigger = () => {
      if (this.$screen.md.matches) {
        cleanupTrigger();
      } else {
        initializeTrigger();
      }
    };

    adjustTrigger();
    this.$screen.md.addEventListener('change', adjustTrigger);
  },
});
